import { debugMode } from "./config";

export function canBypassLogin(debugEnabled: boolean, bypassRequested: boolean): boolean {
  return debugEnabled && bypassRequested;
}

export const demoMode = import.meta.env.VITE_DEMO_MODE !== "false";
export const bypassLogin = canBypassLogin(debugMode, import.meta.env.VITE_BYPASS_LOGIN === "true");
export const microsoftLoginEnabled = !demoMode && !bypassLogin;
